import { useEffect, useState } from "react";

import { sortVenueType } from "@/utils/sortVenueType";
import { GUEST_END_POINTS } from "@/constants/guest/endPoints";
import customAxios from "@/custom/custom-axios";
import { VenueType } from "@/types/owner/task/venueType";
import { debugLog } from "utils/debugLog";

/* 物件タイプを取得 */
export const useVenueType = () => {
  const [venuetypeList, setVenuetypeList] = useState<VenueType[]>([]);
  const [isVenuetypeLoading, setIsVenuetypeLoading] = useState<boolean>(false);
  const [isVenuetypeError, setIsVenuetypeError] = useState<any>("");

  useEffect(() => {
    (async () => {
      try {
        setIsVenuetypeLoading(true);
        const res = await customAxios.get(GUEST_END_POINTS.TASK.VENUE_TYPE);
        const resData = res.data as VenueType[];
        debugLog(resData);
        // その他のみ外す
        let venutypeListTmp = resData.filter((venuetype) => venuetype.id !== 3);
        // トランクルームの並び替え
        venutypeListTmp = sortVenueType(venutypeListTmp, 9, 3);
        // レンタルスペースの並び替え
        venutypeListTmp = sortVenueType(venutypeListTmp, 10, 3);
        // シェアハウスの並び替え
        venutypeListTmp = sortVenueType(venutypeListTmp, 8, 3);
        // 宿泊施設の並び替え
        venutypeListTmp = sortVenueType(venutypeListTmp, 11, 3);
        setVenuetypeList([...venutypeListTmp]);
      } catch (e: any) {
        console.error("get venuetype error", e);
        setIsVenuetypeError(e);
      } finally {
        setIsVenuetypeLoading(false);
      }

      return () => {
        setVenuetypeList([]);
      };
    })();
  }, []);

  return {
    venuetypeList,
    isVenuetypeLoading,
    isVenuetypeError
  };
};
